<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：个人中心</div>
    </div>
    <div class="list-content">
      <div class="pass">
        <div class="title">
          <div class="name">密码修改</div>
        </div>
        <div class="box">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item type="password" label="旧密码" prop="oldPass">
              <el-input v-model="ruleForm.oldPass"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="pass" required>
              <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass" required>
              <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
              <span class="btn3" @click="submitForm('ruleForm')">确认修改</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="info">
        <div class="title">
          <div class="name">个人信息</div>
        </div>
        <div class="box">
          <el-form :model="infoForm" status-icon :rules="rules" ref="infoForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="昵称" prop="name">
              <el-input v-model="infoForm.name"></el-input>
            </el-form-item>

            <el-form-item>
              <span class="btn3" @click="submitForm('infoForm')">确认修改</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {updatePassword, updatePasswordAdmin} from "@/api/index";
import {getAdminDetail, updateAdminDetail} from "@/api/admin";
export default {
  name: "pass",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      id:'',
      ruleForm: {
        pass: '',
        checkPass: '',
        oldPass: ''
      },
      infoForm:{
        name:''
    },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        oldPass: [
          { required: true, message: '请输入旧密码', trigger: 'blur'  }
        ]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.adminuser
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 3
    })
    this.infoForm.name = this.user.nickname
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(formName == 'ruleForm') {
            this.setpass()
          }
          if(formName == 'infoForm') {
            this.setInfo()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    async setInfo(){
      let _res = await updateAdminDetail(
        this.infoForm.name
      );
      if (_res.code === 200) {
        this.$message.success(_res.message)
        this.getUserInfo()
      } else {
        this.$message.error(_res.message)
      }
    },

    async getUserInfo(){
      let _data = await getAdminDetail();
      if (_data.code === 200) {
        this.$store.state.adminuser = _data.data
        await window.localStorage.setItem('adminuser', JSON.stringify(_data.data))
      }
    },

    async setpass() {
      let _res = await updatePasswordAdmin(
        this.ruleForm.oldPass,
        this.ruleForm.checkPass,
      );
      if (_res.code === 200) {
        this.$message.success(_res.message)
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/adminlogin')
        })
      } else {
        this.$message.error(_res.message)
      }
    },

  },
  watch: {

  },
  filters: {}
}
</script>
<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    //background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .pass {
      width: 40%;
      margin-right: 5%;
      box-shadow: #f2f3f4 0px 0px 10px;
    }
    .info {
      width: 40%;
      margin-left: 5%;
      box-shadow: #f2f3f4 0px 0px 10px;
    }

    .title {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .name {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
    }
    .box {
      width: 100%;
      margin: 0 auto;
      min-height: 400px;
      border-radius: 10px;
      padding: 20px;
      background-color: #ffffff;
      padding-top: 50px;
      .btn3 {
        display: block;
        width: 150px;
        height: 40px;
        background-color: #3381c3;
        border-radius: 20px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        margin: 0 auto;
        margin-left: calc(50% - 120px);
      }
    }

  }
}
</style>


